import { withQuery } from '../data/withQuery';
import * as S from '../description/ProductAccordionCustom.styles';

type PropTypes = {
  className?: string;
  product: any;
};
const ProductAccordionCustom = ({ product, className }: PropTypes) => {
  const accordionData = product?.pdp_accordion_custom_block?.reference;
  const accordionDescription = accordionData?.section_description?.value;
  const accordionContent = accordionData?.section_content?.value;
  if (!product || !accordionData) {
    return null;
  }
  return (
    <S.Wrapper data-cy="product-accordion-custom">
      <S.Context dangerouslySetInnerHTML={{ __html: accordionDescription }} />
      <S.Context dangerouslySetInnerHTML={{ __html: accordionContent }} />
    </S.Wrapper>
  );
};
ProductAccordionCustom.displayName = 'ProductAccordionCustom';
export default withQuery(ProductAccordionCustom);
